// removed by extract-text-webpack-plugin
module.exports = {"promotions":"NLM3y_5pz25bzs9bLNXPP"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/RealtorAdditionalPromotionContainer/RealtorAdditionalPromotionContainer.scss
// module id = 1858
// module chunks = 0